/////////////////////////////////
// Load bootstrap (must always be required at top)
/////////////////////////////////
const {bootstrap, ready, loaded} = require("bootstrap");

/////////////////////////////////
// Debugger
/////////////////////////////////

const debug = require("services/debugger");

debug.expose({
	axios: require("axios"),
	env: require("services/env"),
	userStore: require("stores/UserStore"),
	teachersStore: require("stores/TeachersStore"),
	mobx: require("mobx"),
	messageStore: require("stores/MessagesStore"),
	moment: require("moment"),
	hourSlotStore: require("stores/HourSlotsStore"),
	cartStore: require("stores/CartStore"),
	animateBodyScrollToAnchorElement: require("helpers/scroll").animateBodyScrollToAnchorElement,
	renderer: require("services/renderer"),
	orderStore: require("stores/OrderStore"),
	nevermore: require("nevermorejs"),
	notificationStore: require("stores/NotificationsStore")
})
;

/////////////////////////////////
// Route definitions
/////////////////////////////////

const router = require("services/router");

router.define({
	"find-teachers": require("routes/find-teachers")
});

/////////////////////////////////
// Register components
/////////////////////////////////

const renderer = require("services/renderer");

renderer.register("web", {

	mixins: {
		buttons: {
			Burger: require("components/mixins/BurgerTrigger"),
			Close: require("components/mixins/CloseTrigger"),
			Toggle: require("components/mixins/Toggle"),
			Expander: require("components/mixins/Expander")
		},

		modals: {
			Container: require("components/modals/ModalContainer")
		}
	},

	backend: {
		forms: {
			TeacherProfile: require("components/backend/TeacherProfileForm"),
			TeacherSettings: require("components/backend/TeacherSettingsForm"),
			StudentProfile: require("components/backend/StudentProfileForm"),
			StudentSettings: require("components/backend/StudentSettingsForm"),
		},

		Notifications: require("components/backend/Notifications"),
		Avatar: require("components/backend/Avatar"),
		MobileAvatar: require("components/backend/MobileAvatar"),
		NameTag: require("components/backend/NameTag"),
		Chat: require("components/backend/chat/Chat"),
		Calendar: require("components/backend/calendar/Calendar"),
		BookingList: require("components/backend/bookings/BookingList"),
		UpcomingBookings: require("components/backend/upcoming-bookings/UpcomingBookings"),
		InboxLink: require("components/backend/InboxLink"),
		ProfileUrl: require("components/backend/ProfileUrl"),
		BalanceList: require("components/backend/balance/BalanceList")
	},

	frontend: {
		SearchBox: require("components/frontend/SearchBox"),
		SearchLight: require("components/frontend/SearchLight"),
		ReviewComposer: require("components/frontend/ReviewComposer"),
		ReviewList: require("components/frontend/ReviewList")
	},

	checkout: {
		BookingRequest: require("components/checkout/BookingRequest"),
		ChatRequest: require("components/checkout/ChatRequest"),
		BookingBuilder: require("components/checkout/BookingBuilder"),
		Cart: require("components/checkout/Cart"),
		Overview: require("components/checkout/Overview"),
		ReceiptNav: require("components/checkout/ReceiptNav")
	}

});

/////////////////////////////////
// Bootstrap
/////////////////////////////////

const logger = require("services/logger");
const {wait} = require("helpers/throttle");

ready.pipe(payload => {
	// At this point the application was bootstrapped and is ready
	// but has not yet finished the pipeline
	// Any scripts ran at this point will be executed before the "preloader" is hidden (the white overlay)
	try {

		//require("modules/booking")();

		require("modules/object-fit")();
		require("modules/nav-onscroll")();
		require("modules/icon-animation")();
		require("modules/teacher-responsive")();
		require("modules/modal")();
		require("modules/video-modal")();
		require("modules/chat")();
		require("modules/scrollbar")();
		require("modules/faq")();
	}
	catch (err) {
		logger.error(err);
	}

	// Make sure you keep this return as it continues to pipe the payload
	// towards the end of the pipeline
	return payload;
});

bootstrap.dispatch()
	.then(payload => wait(100 /* preloader animation time here */, payload))
	.then(payload => {
		// At this point the application was bootstrapped and is ready.
		// You can require your javascript code here and be 100% sure it is ran in the browser.
		// Everything here will be ran after the "preloader" is hidden

		try {

			require("components/frontend/cookie-notice")();
			require("modules/animations")();
			require("modules/scrollbar")();

		}
		catch (err) {
			logger.error(err);
		}

		// Make sure you keep this return as it continues to pipe the payload
		// towards the end of the pipeline
		return payload;
	})
	.then(() => logger.info("The application was bootstrapped."))
	.then(() => loaded.trigger());



// WEBPACK FOOTER //
// ./resources/js/web.js